import { render, staticRenderFns } from "./juniperaktarim.vue?vue&type=template&id=48059104&"
import script from "./juniperaktarim.vue?vue&type=script&lang=js&"
export * from "./juniperaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports